import React from 'react';
import { btnSecondary, card } from '../ui/Kit';

// A server error (500) or no connection: a friendly message, the reference to quote, and Retry — never raw error text.
export const isServerError = (e) => !e || !e.status || e.status >= 500;

export default function LoadError({ error, what = 'this page', onRetry }) {
  return (
    <div role="alert" className={card + ' p-6'} data-testid="load-error">
      <p className="text-base font-bold text-[#0F172A]">We couldn’t load {what}.</p>
      <p className="text-sm text-[#475569] mt-1">{error && error.status
        ? 'Something went wrong on our side. Please try again — if it keeps happening, send us the reference below.'
        : 'Check your connection and try again.'}</p>
      {error && error.reference && <p className="text-xs text-[#64748B] mt-2">Reference: <span className="font-mono">{error.reference}</span></p>}
      <button className={btnSecondary + ' mt-4'} onClick={onRetry}>Retry</button>
    </div>
  );
}
